import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-templates',
  templateUrl: './templates.component.html',
  styleUrls: ['./templates.component.scss']
})
export class TemplatesComponent implements OnInit {
  activeTemplateTab: 'email' | 'checkout' | 'product' = 'email';

  constructor() { }

  ngOnInit(): void {
  }

  selectTemplateTab(tab: 'email' | 'checkout' | 'product'): void {
    this.activeTemplateTab = tab;
  }

}
